import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "./firebaseConfig";

const ALLOWED_TYPES = [
  "image/jpeg", "image/png", "image/gif", "image/webp", "image/svg+xml",
  "application/pdf",
  "text/plain", "text/csv",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/zip",
];

const MAX_FILE_SIZE_MB = 10;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

const sanitizeFileName = (name) =>
  name.replace(/[^a-zA-Z0-9._-]/g, "_").slice(0, 200);

export const uploadFile = async (file) => {
  if (!file) throw new Error("Dosya seçilmedi.");

  if (!ALLOWED_TYPES.includes(file.type)) {
    throw new Error(
      `Desteklenmeyen dosya türü: "${file.type}". İzin verilen türler: resim, PDF, metin, Office belgesi, ZIP.`
    );
  }

  if (file.size > MAX_FILE_SIZE_BYTES) {
    throw new Error(
      `Dosya boyutu ${MAX_FILE_SIZE_MB} MB sınırını aşıyor (${(file.size / 1024 / 1024).toFixed(1)} MB).`
    );
  }

  const safeFileName = sanitizeFileName(file.name);
  const uniqueName = `${Date.now()}_${safeFileName}`;
  const storageRef = ref(storage, `uploads/${uniqueName}`);

  try {
    const snapshot = await uploadBytes(storageRef, file);
    const downloadURL = await getDownloadURL(snapshot.ref);
    return downloadURL;
  } catch (error) {
    throw new Error("Dosya yüklenemedi: " + error.message);
  }
};